import React from 'react'

const Banner = (props) => (
    <section id="banner" className="major">
        <div className="inner">
            <header className="major">
                <h1>Hi, my name is Jody</h1>
            </header>
            <div className="content">
                <p>This is a collection of my most recent development projects, feel free to look around or contact me from the form below.</p>
                <ul className="actions">
                    <li><a href="#one" className="button next scrolly">My Projects</a></li>
                </ul>
            </div>
        </div>
    </section>
)

export default Banner



// WEBPACK FOOTER //
// ./src/components/Banner.js